import doAsyn from '@tencent/do-asyn';

const ua = navigator.userAgent.toLowerCase();

function isWXEnv() {
    return ua.indexOf('micromessenger') > -1;
}

function isQQEnv() {
    return ua.match(/QQ/i) === "qq";
}

function getGjMachineId() {
    return new Promise(function (resolve, reject) {
        doAsyn.gj(() => {
            TcsJSBridge.invoke("getInfo", {
                key: "guid"
            }, function (res) {
                resolve(res && res.err_msg === "ok" ? res.ret : "");
            });
        })
    })
}


function isGjEnv() {
    const gjUa = ['wifimanager', 'secure', 'clean', 'game', 'gallery', 'pim', 'album'];
    let flag = false;
    for (let _u of gjUa) {
        if (ua.indexOf(_u) > -1) {
            flag = true;
            break;
        }
    }
    return flag;
}

function download(posId, downloadUrl, pkgName, context) {
    return new Promise(function (resolve, reject) {
        doAsyn.gj(() => {
            TcsJSBridge.invoke("downloadAndReportQt", {
                url: downloadUrl,
                pkgName: pkgName,
                context: context,
                positionId: posId,
            }, function (res) {
                if (res.err_msg === "ok" && res.ret === 0) {
                    resolve({
                        ret: 0,
                        msg: 'suc'
                    });
                } else {
                    reject({
                        ret: res.ret,
                        msg: "调用失败，err_msg: " + res.err_msg + " res.ret: " + res.ret
                    });
                }
            });
        })
    })

}

export {
    getGjMachineId,
    isGjEnv,
    download,
    isWXEnv,
    isQQEnv
}